import { Store } from "pullstate";
import api from "$services/api";

const initialMetric = {
    etlRun: "",
    clientGroupCount: 0,
    clientGroupCountChange: 0,
    clientCount: 0,
    clientCountChange: 0,
    existingProjectCount: 0,
    existingProjectCountChange: 0,
    potentialProjectCount: 0,
    potentialProjectCountChange: 0,
    teamMemberCount: 0,
    teamMemberCountChange: 0,
    officeCount: 0,
    officeCountChange: 0,
};

const initialState = [{ ...initialMetric }];

const calculateChanges = (data) => {
    return data.map((item, index) => {
        return Object.keys(item).reduce((obj, key) => {
            obj[key] = item[key];
            if (index < data.length - 1) {
                obj[`${key}Change`] = Math.round(data[index + 1][key] / item[key]);
                obj[`${key}ChangeAmount`] = item[key] - data[index + 1][key];
            }

            return obj;
        }, {});
    });
};

export const MetricsStore = new Store(initialState);

export const fetchMetrics = async () => {
    try {
        const response = await api.get("/api/admin/metrics");

        MetricsStore.update((s) => {
            return calculateChanges(response) || [];
        });
    } catch {}
};
